export default __webpack_public_path__ + "static/media/IAMA-Logo-Black.5060b34c.png";